module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-144x144-c565d70cc3b45da1b58c9e5ae03aeaa8.png";